import React, { useEffect } from 'react';
import ReactMarkdown from 'react-markdown'
import styled from "@emotion/styled";
import { dark_sky_blue, greeny_blue, customGreen, bluegreen, color_text_default, color_text_link } from '../../../constants/colors';
import ReviewUserContainer from '../../../hooks/ReviewUserContainer';
import { setPassword } from '../../../api/controllers/users';
import TextField from '../../../components/forms/TextField';
import Button from '../../../components/general/Button';
import PageError from '../../../components/general/PageError';
import { getSparkBaseUrl } from '../../../constants/Urls';

interface Props {
    appId: string
};

const ReviewUserManagement: React.FC<Props> = (props: Props) => {
    const reviewUserContainer = ReviewUserContainer.useContainer();
    const [password, setPassword] = React.useState<string>("");
    useEffect(() => {
        reviewUserContainer.loadApp(props.appId);
    }, [])

    const buildLink = () => {
        const userKey = reviewUserContainer.member?.email.split("@")[0];
        const link = `${getSparkBaseUrl()}/review/${props.appId}?key=${userKey}`;
        return link;
    }
    return (
        <CenterTopDiv>
            <ContentContainer>
                <TextField
                    disabled={reviewUserContainer.loading}
                    useForm={false}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    label="Password. This password will be used to access newly created links. Once you navigate away, you will not be able to see this password again."
                    placeholder="Enter a password for the new link here. If you create a new link, the old one will stop working."
                />
                {reviewUserContainer.member?.email ? buildLink() : "No link yet"}
                <ButtonRow>
                    <Button
                        disabled={!reviewUserContainer.member?.email?.length}
                        loading={reviewUserContainer.loading}
                        text="Copy existing link"
                        onClick={async () => {
                            const link = buildLink();
                            await navigator.clipboard.writeText(link);
                        }} themes={["primary"]} />
                    <Button
                        loading={reviewUserContainer.loading}
                        text="Create new link with password"
                        onClick={async () => {
                            await reviewUserContainer.createNewReviewUser(props.appId, password);
                            await reviewUserContainer.loadApp(props.appId);
                            setPassword("");
                        }} themes={["primary"]} />
                </ButtonRow>
                <Label><a href="https://www.loom.com/share/cbec1503d3f542d39198519ca8417eec?sid=42a2385b-a355-4bb9-bc40-d45abbdc37bb" target="_blank">Click here to learn more about this feature.</a></Label>
                <StyledPageError errors={reviewUserContainer?.error?.length ? [reviewUserContainer.error] : []} onClear={() => reviewUserContainer.setError("")} />
            </ContentContainer>
        </CenterTopDiv>
    )
}


const Label = styled.div`
    font-weight: 400;
    font-size: 20px;
    color: ${color_text_default};
    margin-left: 16px;
    margin-bottom: 8px;
    a {
        color: ${color_text_link};    
    }
`;

const ButtonRow = styled.div`
    display: flex;
    flex-direction: row;
`

const ContentContainer = styled.div`
    width: 40%;
`;

const CenterTopDiv = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    margin-top: 32px;
`

const StyledPageError = styled(PageError)`
    bottom: 100px;
`


export default ReviewUserManagement;
